export const styles = theme => ({

  // color
  statusValue: {
    fontSize: '32px',
    fontWeight: 'bold',
    fontFamily: theme.typography.fontKanit,
  },
  statusText: {
    borderRadius: 5,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamiry: theme.typography.fontKanit,
    fontSize: 12,
  },
  boxContent: {
    border: '1px solid #ccc',
  },
  title: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '16px',
    fontWeight: '400',
  },
  status: {
    marginLeft: theme.spacing(1),
  },
  unit: {
    marginLeft: theme.spacing(1),
  },
  unitAll: {
    marginLeft: 4,
    fontFamily: theme.typography.fontKanit,
    fontSize: '16px',
  },
  icon: {
    fontSize: '40px',
  },
  shapeCircle: {
    backgroundColor: theme.palette.primary.main,
    width: 20,
    height: 20, 
    borderRadius: '50%', 
    padding: '3px',
    fontWeight: '600',
    fontFamily: theme.typography.fontKanit,
    fontSize: '13px',
  },
  shapeAllCircle: {
    backgroundColor: theme.palette.primary.main,
    width: '34px',
    height: '34px', 
    borderRadius: '50%', 
    padding: 9,
    fontWeight: '400',
    fontFamily: theme.typography.fontKanit,
    fontSize: '13px',
    marginLeft: 15,
  },
  colorAll: {
    fontFamily: theme.typography.fontKanit,
    color: 'white',
    fontSize: '18px',
  },

  // color
  blank: {
    color: '#000',
    background: '#ccc',
    constrastColor: '#000',
  },
  one: {
    background: '#db802b',
    constrastColor: '#000',
  },
  two: {
    background: '#ffc000',
    constrastColor: '#000',
  },
  three: {
    background: '#00b050',
    constrastColor: '#fff',
  },
  four: {
    color: '#fff',
    background: '#003cfa',
    constrastColor: '#fff',
  },
  five: {
    color: '#fff',
    background: '#ff0000',
    constrastColor: '#fff',
  },
});